module.exports = __webpack_public_path__ + "static/media/background.9f5f705e.jpg";